import React, { useEffect } from 'react';
import usePageTitle from '../../utils/usePageTitle';
import { Layout, Spin, Button, Space } from 'antd';
import '../../style/component.css'
import Headers from '../header/Header';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/authContext';
import StaffSidebarMenu from '../sidebar/StaffSidebarMenu';
import { getDashboard } from '../../feature/admin/dashboard/DashboardSlice';
import { getDashboard as staffGetDashboard } from '../../feature/staffs/dashboard/DashboardSlice';
import { useDispatch, useSelector } from 'react-redux';
import AttendanceLock from './AttendanceLock';
import { useLocation } from "react-router-dom";

const { Content } = Layout;

const StarffLayout = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { getStaffRole } = useAuth();
    const { dashboardData, isLoading } = useSelector((state) => state.dashboards);

    const ignoreRoutes = ["/staff/my-attendance", "/staff/profile-details", "/staff/edit-profile-details", "/staff/aboutus", "/staff/privacy-policy", "/staff/term-condition"];

    const shouldLock = !dashboardData?.isPresent && !ignoreRoutes.includes(location.pathname);

    usePageTitle("Staff")

    useEffect(() => {
        dispatch(getDashboard());
        dispatch(staffGetDashboard());
    }, []);

    useEffect(() => {
        if (!dashboardData) return;
        getStaffRole(dashboardData.role);
    }, [dashboardData?.role]);

    useEffect(() => {
        if (shouldLock) {
            document.body.classList.add("locked");
        } else {
            document.body.classList.remove("locked");
        }
    }, [shouldLock]);

    const footerMenus = [
        { label: 'Recent Activity', path: '/staff/recent-activity' },
        { label: 'Compliance Status', path: '/staff/compliance-status' },
        { label: 'Waitlist Children', path: '/staff/waitlist-children' },
        {
            label: 'Pending Action',
            path: '/staff/pending-action',
        },
        {
            label: 'Leave Calender',
            path: '/staff/leave-calender',
        },
    ];

    return (
        <Layout>
            <Headers />
            <Layout>
                <StaffSidebarMenu />
                <Layout className='main'>
                    <Content className='content'>
                        {isLoading ? <Spin size='medium' fullscreen /> :
                            <div style={{ minHeight: "100vh" }}>
                                <Outlet />
                            </div>}
                        {!isLoading && shouldLock && <AttendanceLock />}
                        {dashboardData?.role === "Manager" && (
                            <div className="footer-container">
                                <Space>
                                    {footerMenus.map((item) => {
                                        const isActive = location.pathname === item.path;
                                        return (
                                            <Button
                                                key={item.path}
                                                shape="round"
                                                type={isActive ? 'primary' : 'default'}
                                                className={isActive ? 'active-footer-btn' : 'footer-btn'}
                                                onClick={() => navigate(item.path)}
                                                size='medium'
                                            >
                                                {item.label}
                                            </Button>
                                        );
                                    })}
                                </Space>
                                <p className="footer-text">
                                    © {new Date().getFullYear()} Cubcare. All rights reserved.
                                </p>
                            </div>
                        )}
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    );
};

export default StarffLayout;
